import Backbone from 'backbone';
import PropertyListModel from 'models/properties/propertyListModel';

// jdj-2015-03-27 - TODO - determine if this collection should also be enforced by property UUID in the read-all
// request either at client or server side

const PropertyListCollection = Backbone.Collection.extend({
    url: '/api/site',
    model: PropertyListModel,
    comparator: 'url',
    parse(data) {
        const that = this;

        //jdj-2015-03-27, the /api/site endpoint will return a wrapped payload,
        //make sure the response was successful by inspecting the success element

        if (data && data.success && data.success === true) {
            that.add(data.hasOwnProperty('data') ? data.data : data);
        }

        return this.models;
    },
});
export default PropertyListCollection;
